import { ContentArticle } from '../types';
import { beginnersguideplaycast } from './beginnersguideplaycast';
import { bestgamestostream } from './bestgamestostream';
import { besttoolsgamestreaming } from './besttoolsgamestreaming';
import { boosttwitchengagement } from './boosttwitchengagement';
import { coopgaming } from './coopgaming';
import { coopstreamingtwitch } from './coopstreamingtwitch';
import { EpicFortniteApple } from './EpicFortniteApple';
import { evolutiongamestreamingtech } from './evolutiongamestreamingtech';
import { mobilestreamingsetup } from './mobilestreamingsetup';
import { peerstreamingplaycast } from './peerstreamingplaycast';
import { peertopeergaming } from './peertopeergaming';
import { peertopeerplatform } from './peertopeerplatform';
import { peertopeerstreaminggaming } from './peertopeerstreaminggaming';
import { playcastvsparsec } from './playcastvsparsec';
import { PointerKeyboardLock } from './PointerKeyboardLock';
import { Release1x0x0 } from './Release1x0x0';
import { Release1x1x0 } from './Release1x1x0';
import { Release1x2x0 } from './Release1x2x0';
import { streamcoopgames } from './streamcoopgames';
import { TwitchSanDiego } from './TwitchSanDiego';
import { UnbearableLatency } from './UnbearableLatency';
import { WebGLPlatform } from './WebGLPlatform';

export const articles: { [key: string]: ContentArticle } = {
  'beginners-guide-playcast': beginnersguideplaycast,
  'best-games-to-stream': bestgamestostream,
  'best-tools-interactive-game-streaming': besttoolsgamestreaming,
  'boost-viewer-engagement-twitch-playcast-interactive': boosttwitchengagement,
  'co-op-in-gaming': coopgaming,
  'co-op-game-streaming-twitch-guide': coopstreamingtwitch,
  'epic-fortnite-apple': EpicFortniteApple,
  'evolution-game-streaming-technology': evolutiongamestreamingtech,
  'mobile-streaming-on-twitch': mobilestreamingsetup,
  'set-up-peer-to-peer-streaming-playcast': peerstreamingplaycast,
  'peer-to-peer-gaming': peertopeergaming,
  'best-platforms-peer-to-peer-gaming-playcast': peertopeerplatform,
  'peer-to-peer-streaming-online-gaming': peertopeerstreaminggaming,
  'playcast-parsec-best-streaming-platform-interactive-gaming': playcastvsparsec,
  'pointer-keyboard-lock': PointerKeyboardLock,
  'release-1-0-0': Release1x0x0,
  'release-1-1-0': Release1x1x0,
  'release-1-2-0': Release1x2x0,
  'stream-coop-games-with-twitch-viewers-using-playcast': streamcoopgames,
  'twitchcon-san-diego': TwitchSanDiego,
  'playcast-tackles-latency-deliver-interactive-video-game-streaming': UnbearableLatency,
  'webgl-platform': WebGLPlatform,
};
